// Zweck: Artikelcodes eindeutig und UPC/EAN in gleichwertigen Schreibweisen finden.
// Kontext: Nur gültige GTIN-Barcodes vereinheitlichen; Artikelnummern unverändert lassen. Stand: 20.10.2026.
import type { WarehouseArticle } from '../interfaces/warehouse';

function gtin(value: string): string | null {
  const code = value.trim();
  if (!/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(code)) return null;
  const sum = [...code.slice(0, -1)]
    .reverse()
    .reduce(
      (total, digit, index) =>
        total + Number(digit) * (index % 2 === 0 ? 3 : 1),
      0,
    );
  if ((10 - (sum % 10)) % 10 !== Number(code.at(-1))) return null;
  return code.padStart(14, '0');
}

export function warehouseCodeMatches(
  article: Pick<WarehouseArticle, 'number' | 'codes'>,
  raw: string,
): boolean {
  const code = raw.trim();
  if (!code) return false;
  const canonical = gtin(code);
  return (
    [article.number, ...article.codes].some(
      (value) => value.trim().toLowerCase() === code.toLowerCase(),
    ) ||
    (canonical !== null &&
      article.codes.some((value) => gtin(value) === canonical))
  );
}
